//Model na potrzeby frontu do stworzenia maszyny stanów
export enum AuthenticationMode {
  Local = "local", //z logowaniem
  Guest = "guest", //rezerwacja jako gość
  Sso = "sso", //logowanie sso
  LocalAndGuest = "localAndGuest",
  LocalAndSso = "localAndSso",
  GuestAndSso = "GuestAndSso",
  LocalAndGuestAndSso = "localAndGuestAndSso",
}
